module.exports = __webpack_public_path__ + "static/media/2025-Sports-Masterclass-Social-Image.27f4d820.jpg";